<div class="loadWrapper" *ngIf="showProgress">  
    <div class="loader"></div>  
  </div>